import { Filter, OrderByCondition } from "@/types/filter.type";
import { Pagination } from "@/types/pagination.type";

import axios from "./api";
import { responseHandlerDefault } from "./../utils/handler.util";
import { ImageLossAlert } from "@/types/issueMonitoring.type";

export const getImageLossAlert = (
  page?: number,
  size?: number,
  fromDate?: Date | undefined,
  toDate?: Date | undefined,
  filter?: Filter,
  order?: OrderByCondition
): Promise<Pagination<ImageLossAlert>> => {
  const params: {
    page?: number;
    size?: number;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    filter?: Filter;
    order?: OrderByCondition;
  } = {};
  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }
  if (fromDate) {
    params.fromDate = fromDate.toISOString();
  }
  if (toDate) {
    params.toDate = toDate.toISOString();
  }
  if (filter) {
    params.filter = filter;
  }
  if (order) {
    params.order = order;
  }

  return axios.get(`/imagelossalert/`, { params }).then(responseHandlerDefault);
};

export const putImageLossAlert = (entity: ImageLossAlert): Promise<ImageLossAlert> => {
  return axios.put<ImageLossAlert>(`/imagelossalert/`, entity).then(responseHandlerDefault);
};

export const postImageLossAlert = (entity: ImageLossAlert): Promise<ImageLossAlert> => {
  return axios.post<ImageLossAlert>(`/imagelossalert/`, entity).then(responseHandlerDefault);
};
